import React from "react";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import { TextField, FormLabel } from "components/ui";
import { FormControl, MenuItem, Select, Typography } from "@mui/material";

import { useAppDispatch, useAppSelector } from "hooks/redux";
import { actions, selectors } from "store/caseCreate";

import { Impressions } from "./Impressions";
import { OtherFiles } from "./OtherFiles";
import { StepsStartSelector } from "./StepsStartSelector";
import { useAtom } from "jotai";
import { atomWithStorage } from "jotai/utils";
import { Colors } from "consts/colors";
type choosenFileType = "physical" | "digital" | null;
const choosenType = atomWithStorage<choosenFileType>(
  "newOrderImpressionType",
  null
);

export const AdditionalInfoStep = () => {
  const [choosenFileType, setFileType] = useAtom(choosenType);
  const isError = useAppSelector((state) => state.newCase.isError);
  const dispatch = useAppDispatch();
  const notes = useAppSelector(selectors.getNotesSelector);
  const notesChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(actions.setNotes(event.target.value));
  };
  const errormsg = isError
    ? "Please complete one of the following options: upload an STL file, provide physical quantities for PVS impressions, or select the Scanner option."
    : null;

  return (
    <Grid container spacing={6}>
      <Grid item md={12}>
        <Typography variant="subtitle2" sx={{ color: Colors.ERROR }}>
          {errormsg}
        </Typography>
        <FormControl sx={{ width: 1 / 2, mt: 2 }}>
          <Select
            labelId="choosenFileType-label"
            id="choosenFileType-select"
            value={choosenFileType}
            displayEmpty
            size="small"
            inputProps={{ "aria-label": "Without label" }}
            onChange={(e) => {
              setFileType(e.target.value as Exclude<choosenFileType, null>);
            }}
            sx={{}}
          >
            <MenuItem value={"digital"}>Digital Files</MenuItem>
            <MenuItem value={"physical"}>Physical PVS Impressions</MenuItem>
          </Select>
        </FormControl>
        {choosenFileType && (
          <>
            {choosenFileType === "physical" ? <Impressions /> : null}
            {choosenFileType === "digital" ? <OtherFiles /> : null}
            <StepsStartSelector />
            <Box mt={3}>
              <FormLabel
                targetLabel="Additional info"
                label="If you have any additional treatment preferences, please provide them here:"
              >
                <TextField
                  value={notes}
                  onChange={notesChangeHandler}
                  fullWidth
                  multiline
                  rows={2}
                  maxRows={3}
                  placeholder="Type notes here..."
                />
              </FormLabel>
            </Box>
          </>
        )}
      </Grid>
      {/* <Grid item md={6}>
        <InformBlock title="Note" text={text} />
      </Grid> */}
    </Grid>
  );
};
